import { Pipe, PipeTransform } from '@angular/core';

import { maskValue } from '../../directive/input-mask/mask.helper';
import { Mask } from '../../class/workflow.type';

/**
 * Transform value using CU masks
 */
@Pipe({
  name: 'mask',
  standalone: false
})
export class MaskPipe implements PipeTransform {
  public transform(value: string, maskName: Mask): string {
    return maskValue(maskName, value);
  }
}
